import axios from 'axios';
import { JWT } from '../../config';
import { getApiUrl } from '../../lib/function';
import { Store } from '../../store';
import { AuthAction } from './AuthAction';
import { GroupAction } from './GroupAction';
import { AlertConstant, UserConstant } from '../reducer';

const CheckEmail = async (email) => {
    const API_URL = getApiUrl('user');
    const ret = await axios.post(API_URL + '/emaildupcheck', { email }, JWT());
    return ret.data;
}

const CreateWithoutAuth = (info) => async (dispatch) => {
	const API_URL = getApiUrl('user', info.region);
	const data = { data: info };
	const ret = await axios.post(API_URL + '/user', data, {
		headers: { 'x-ray-device': Store.getState().ProgramReducer?.site?.toUpperCase() }
	});
	return ret.data;
}

const Unregister = (info) => async (dispatch) => {
	const API_URL = getApiUrl('user');
	const user = Store.getState().AuthReducer.user;
	const ret = await axios.post(API_URL + '/unregister', { data : info }, JWT());
	if (ret.data.status == 'success') {
		if(user.email === info.email){
			const data_users = await UserAction.GetUserIdsByGroupId(user.groupId);
			if(data_users.data.length === 0)
				await GroupAction.UpdateHasMember(user.groupId, false, user.region);

			dispatch(AuthAction.Logout());
		}else{
			dispatch({ type: UserConstant.REMOVED, email : info.email });
		}
	} else {
		dispatch({ type: AlertConstant.ERROR, data: ret.data.err, msg : "Error", show : true });
	}
};

const GetUserIdsByGroupId = async (_id) => {
	const API_URL = getApiUrl('user');
	const formData = {
		data: { _id }
	};
	const ret = await axios.post(API_URL + '/useridsbygroupid', formData, JWT());
	return ret.data;
}

const GetUserIdsByGroupIdNoAuth = async (_id, region) => {
	const API_URL = getApiUrl('user');
	const formData = {
		data: { _id, region }
	};
	const ret = await axios.post(API_URL + '/getusersbygroupidnoauth', formData, JWT());
	return ret.data;
}

export const UserAction = {
	CheckEmail,
	CreateWithoutAuth,
	Unregister,
	GetUserIdsByGroupId,
	GetUserIdsByGroupIdNoAuth	
};
